<template>
    <div class="fan-link-box">
        <div class="info">
            <!--i class="ecom-help" /-->
            <strong>Fan link</strong>
            <p>
                <span v-html="txtIntro" />
                <template v-if="isGuest">
                    <br />
                    <a href="#" @click="onLoginClick">{{txtLogin}}</a>
                </template>
            </p>    

            <template v-if="isGuest === false">
                <div v-if="showLink" class="copy">
                    <input type="text" id="fan-link-url" v-model="fanLinkUrl" />
                    <i class="btn ecom-copy" @click="copyToClipboard" />
                </div>
                <div v-if="showCopied" class="copied">
                    <span>{{ txtCopied }}</span>
                    <i class="btn ecom-copy" />
                </div>
                <div v-if="showLoader" class="loader">
                    <div class="input skeleton-box" />
                    <div class="btn skeleton-box" />
                </div>
            </template>
        </div>
    </div>
</template>

<style>


</style>

<script>

import request from '@/Utilities/httpRequest';

export default {
    name: 'FanLink',
    components: {
    },
    props: {
        visible: false,
        groupId: null,
        txtIntro: null,
        txtCopied: null,
        txtLogin: null,
        isGuest: null,
        generateUrl: null,
        loginUrl: null,
    },
    data(){
        return{
            fanLinkUrl: null,
            loading: true,
            copied: false,
        }
    },
    created() {

    },
    mounted(){
        if(this.visible === true && this.fanLinkUrl === null && this.isGuest === false){
            this.getLink();
        }
    },
    watch: {
        visible(val){
            if(val === true && this.fanLinkUrl === null && this.isGuest === false){
                this.getLink();
            }
        }
    },
    computed:{
        showLink(){
            return this.loading === false && this.copied === false;
        },
        showCopied(){
            return this.loading === false && this.copied === true;
        },
        showLoader(){
            return this.loading === true;
        },
    },
    methods: {
        async getLink(){

            this.loading = true;
            try {
                const data = {
                    groupId: this.groupId,
                };
                const response = await request.get(this.generateUrl, data, false);
                this.$emit('loaded');

                if(response.data.hasOwnProperty('fanLinkUrl') && response.data.fanLinkUrl){
                    this.fanLinkUrl = response.data.fanLinkUrl;

                    const elem = document.querySelector('#fan-link-url');                 
                    elem.focus();
                    elem.select();
                }
                else{
                    this.fanLinkUrl = '';
                }
            } catch (error) {

            } finally {
                
            }

            this.loading = false;
        },
        copyToClipboard(event){
            // this will prevent popup being hidden
            event.stopPropagation();
            event.preventDefault();

            // get input element
            const elem = document.querySelector('#fan-link-url');
            // set focus
            elem.focus();
            // select element text/value
            elem.select();

            try{
                // copy "input" text/value
                const successful = document.execCommand('copy');
                if(successful){
                    this.copied = true;

                    setTimeout(() => {
                        this.copied = false;
                    }, 2000);
                }
            }
            catch (error) {
                //alert('unable to copy link');
            }    
        },
        onLoginClick(event){
            event.preventDefault();
            const elem = document.querySelector('#login__link');
            if(elem){
                elem.href = this.loginUrl;
                elem.click();
            }
            else{
                document.location.href = this.loginUrl;
            }
        }
    }
}
</script>